import { createAsyncThunk } from '@reduxjs/toolkit';
import FormResponseApi from '@infrastructure/form-response-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const createFormResponseAsync = createAsyncThunk('formResponse/createFormResponse', async (request, { rejectWithValue }) => {
    try {
        const response = await FormResponseApi.createFormResponse(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFormResponsesByEventIdAsync = createAsyncThunk('formResponse/getFormResponsesByEventId', async (eventId, { rejectWithValue }) => {
    try {
        const response = await FormResponseApi.getFormResponsesByEventId(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFormResponseByIdAsync = createAsyncThunk('formResponse/getFormResponseById', async (id, { rejectWithValue }) => {
    try {
        const response = await FormResponseApi.getFormResponseById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const checkEmailExistsAsync = createAsyncThunk('formResponse/checkEmailExists', async (payload, { rejectWithValue }) => {
    try {
        const response = await FormResponseApi.checkEmailExists(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
